import { css } from 'styled-components';

export const mobileGridArea = css`
	grid-template-areas:
		'${'header '.repeat(7)} fullscreenButton'
		'${'slider '.repeat(8)}';
`;

export const desktopGridArea = css`
	grid-template-areas:
		'header header ${' slider '.repeat(4)} fullscreenButton fullscreenButton'
		'. . ${'slider '.repeat(4)} . .';
`;

export const fullscreenGridArea = css`
	grid-template-areas: '${'slider '.repeat(8)}';
`;

export const minimizedGridArea = css`
	grid-template-areas: '${'header '.repeat(8)} fullscreenButton';
`;
